import { useState } from "react";
import { useCombinedCartAndMenuData } from "./combinedCartAndMenuData";
import { Cart } from "./Cart";
import {
  Badge,
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";
import { Cancel, ShoppingCart } from "@mui/icons-material";
import { OrderType } from "../types/OrderType";
import { useMenuIdFromURL } from "../hooks/menuIdFromURL";
import { useHistory } from "react-router-dom";
import { LAST_ORDER_ID_KEY, LAST_ORDER_MENU_ID } from "./LAST_ORDER_KEYS";

export const CartPopUp = () => {
  const [open, setOpen] = useState(false);
  const { numberOfItemsInCart, clearCart } = useCombinedCartAndMenuData();

  const menuId = useMenuIdFromURL();
  const history = useHistory();

  const confirmOrderToCustomer = (order: OrderType) => {
    setOpen(false);
    clearCart();
    localStorage.setItem(LAST_ORDER_ID_KEY, order.id.toString());
    localStorage.setItem(LAST_ORDER_MENU_ID, menuId);

    history.push(`/menu/${menuId}/order/${order.id}`, order);
  };

  return (
    <>
      <Dialog open={open} fullScreen>
        {numberOfItemsInCart == 0 ? (
          <Box
            display="flex"
            flexDirection="column"
            height="100%"
            sx={{ padding: 2, boxSizing: "border-box" }}
          >
            <Box display="flex" alignItems="center" justifyContent="flex-end">
              <IconButton
                onClick={() => setOpen(false)}
                data-testid="cart-pop-up-close-button"
                size="small"
              >
                <Cancel fontSize="large" />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              flex={1}
              gap={2}
            >
              <ShoppingCart sx={{ fontSize: 72, color: "text.disabled" }} />
              <Typography
                variant="h6"
                fontWeight={600}
                data-testid="test-id-cart-title"
              >
                Your cart is empty
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Add items from the menu to get started
              </Typography>
              <Button
                variant="outlined"
                onClick={() => setOpen(false)}
                sx={{ mt: 1 }}
              >
                Browse menu
              </Button>
            </Box>
          </Box>
        ) : (
          <Cart
            onOrderPlaced={confirmOrderToCustomer}
            onClose={() => setOpen(false)}
          />
        )}
      </Dialog>

      <Button
        aria-label="my-list-button"
        role="button"
        data-testid="test-id-my-cart-pop-up-button"
        onClick={() => setOpen(true)}
        sx={{
          color: "white",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Badge
          badgeContent={numberOfItemsInCart}
          color="success"
          aria-label="number-of-items-in-cart"
          role="text"
          data-testid="test-id-number-of-items-in-cart"
        >
          <ShoppingCart color="inherit" fontSize="large" />
        </Badge>

        <Typography textTransform={"none"}> Cart </Typography>
      </Button>
    </>
  );
};
